import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2101LogicalUnitActionHandler } from "./U2101LogicalUnitActionHandlers";

// Typage des props du composant
interface U2101LogicalUnitDeleteDlgProps {
  u2101LogicalUnitActionHandler: U2101LogicalUnitActionHandler;
  t: TFunction;
  NS: string;
}

function U2101LogicalUnitActionDeleteDlg({ u2101LogicalUnitActionHandler, t, NS }: U2101LogicalUnitDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2101LogicalUnitActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2101LogicalUnitActionHandler.isDeleteDialogOpen} onClose={u2101LogicalUnitActionHandler.onDlgDeleteClose} title={t("lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteLogicalUnitAction", {
          count: u2101LogicalUnitActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2101LogicalUnitActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => (
          <span key={row.logicalUnitActionCode} className="inline-block text-gray-800">
            {`${row.logicalUnitActionCode}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2101LogicalUnitActionDeleteDlg;
